import { render, staticRenderFns } from "./datatables_ikid_class.vue?vue&type=template&id=41740fe1&scoped=true&"
import script from "./datatables_ikid_class.vue?vue&type=script&lang=js&"
export * from "./datatables_ikid_class.vue?vue&type=script&lang=js&"
import style0 from "./datatables_ikid_class.vue?vue&type=style&index=0&id=41740fe1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41740fe1",
  null
  
)

export default component.exports